module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-wrap"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.sendavatar($event)
      }
    }
  }), _c('div', {
    staticClass: "avatar-wrap",
    on: {
      "click": _vm.sendfile
    }
  }, [_vm._m(0)]), _c('div', {
    staticClass: "userinfo-wrap"
  }, [_vm._m(1), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("手机号码")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("format")(_vm.phone)))])]), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require(".././assets/avatar.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("姓名")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("张三丰")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("性别")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("男")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd3066e4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/userinfo.vue
// module id = 121
// module chunks = 0